import { buildMeta } from "../../routeMeta";

export { default } from "../../../src/pages/glossary";

export function meta(args) {
  return buildMeta(
    {
      title: "Glossary — The Atlas of Economic Complexity",
      description:
        "Definitions for the economic complexity, trade, and product-space terms used throughout the Atlas.",
    },
    args,
  );
}
